module.exports = __webpack_public_path__ + "img/20180815_154807_244.838b6343.jpg";